module.exports = __webpack_public_path__ + "static/media/beach.46065f69.png";